import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { withRetry } from 'ml-services-common-react';

const sendWithRetry = (endpoint, method, params, additionalHeaders) => withRetry(() => JsonRPCService.send(endpoint, method, params, additionalHeaders));

export default class SearchService {
    static search(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'search',
            [searchRequestDTO],
            additionalHeaders
        );
    }

    static searchPartial(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchPartial',
            [searchRequestDTO],
            additionalHeaders
        );
    }

    static searchAvailableGroups(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchAvailableGroups',
            [searchRequestDTO],
            additionalHeaders
        );
    }

    static searchByJobNumber(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchByJobNumber',
            [searchRequestDTO],
            additionalHeaders
        );
    }

    static searchBySubmissionNumber_Ext(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchBySubmissionNumber',
            [searchRequestDTO],
            additionalHeaders
        );
    }

    static searchAvailablePolicyFromCurrentUser(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchAvailablePolicyFromCurrentUser',
            [searchRequestDTO],
            additionalHeaders
        );
    }

    static searchAvailableQuoteFromCurrentUser(searchRequestDTO, limit, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchAvailableQuoteFromCurrentUser',
            [searchRequestDTO, limit],
            additionalHeaders
        );
    }

    static searchByName(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchByName',
            [searchRequestDTO],
            additionalHeaders
        );
    }

    static searchByPolicyName(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchByPolicyName',
            [searchRequestDTO],
            additionalHeaders
        );
    }

    static searchByARSPoliciesML(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchByARSPoliciesML',
            [searchRequestDTO],
            additionalHeaders
        );
    }

    static searchPoliciesByPolicyNameSolr(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchPoliciesByPolicyNameSolrML',
            [searchRequestDTO],
            additionalHeaders
        );
    }

    static searchByPolicyNumber(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchByPolicyNumber',
            [searchRequestDTO],
            additionalHeaders
        );
    }
 
    static searchHVQByName(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchHVQByName',
            [searchRequestDTO],
            additionalHeaders
        );
    }

    static searchHVQByQuoteId(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchHVQByQuoteId',
            [searchRequestDTO],
            additionalHeaders
        );
    }

    static searchByJobAndZipCodeWithRestrictions(searchRequestDTO, additionalHeaders = {}) {
        return sendWithRetry(
            getProxiedServiceUrl('search'),
            'searchByJobAndZipCodeWithRestrictions',
            [searchRequestDTO],
            additionalHeaders
        );
    }
}
